export default {
    userStories: {
        title: '1011 Story Collection',
        count: '{count} stories',
        expand: 'Expand',
        collapse: 'Collapse',
        noImage: 'None',
        empty: {
            title: 'No stories yet',
            desc: 'No 1011 stories submitted yet. Waiting for users to submit from the task page.',
        },
        columns: {
            uid: 'UID',
            content: 'Story',
            image: 'Image',
            submittedAt: 'Submitted At',
        },
    },
};
